import React from 'react';
import AddStaffDrawer from 'components/UserDashboardV2/components/addStaffDrawer';
import UserProfilePicChangeModal from '../userProfilePicChangeModal';
import AddDocumentModal from '../addDocumentModal';
import EnrollCourseModal from '../enrollCourseModal';
import AddBatchDrawer from 'components/UserDashboardV2/components/AddBatchDrawer';
import ChangeBatchModal from '../changeBatchModal';
import SavingModal from 'components/SavingModal';
import PageDataLoader from 'components/pageDataLoader';
import UserActionConfirmModal from 'pages/userManagementV3/localComponent/userActionConfirmModal';

const ProfileModals = ({
    editOpen,
    setEditOpen,
    editingStaffForDrawer,
    refetchProfile,
    profilePicModalOpen,
    setProfilePicModalOpen,
    handleRemovePhotoConfirm,
    handleProfilePicModalOk,
    specificUserProfile,
    existingPhotoSrc,
    inputProfilePicRef,
    storeImageFile,
    handleConfirmPhotoChoice,
    handleProfilePicCancel,
    setImgUrl,
    imgUrl,
    imageFile,
    setImageFile,
    documentModal,
    setDocumentModal,
    handleReplaceDocument,
    handleUploadDocuments,
    enrollCourseModalOpen,
    setEnrollCourseModalOpen,
    handleEnrollCourse,
    userId,
    enrolledCourses,
    confirmAction,
    confirmLoading,
    closeConfirmModal,
    handleConfirmAction,
    addBatchDrawerData,
    setAddBatchDrawerData,
    unassignCourseModal,
    setUnassignCourseModal,
    unassigningCourse,
    handleConfirmUnassignCourse,
    changeBatchModalData,
    setChangeBatchModalData,
    handleChangeStudentBatch,
    unassignBatchModal,
    setUnassignBatchModal,
    unassigningBatch,
    handleConfirmUnassignBatch,
    cancelRequestModal,
    setCancelRequestModal,
    cancelingRequest,
    handleConfirmCancelRequest,
    tabLoader,
    pageLoader,
    enrolledCoursesLoading,
    studentFeeLoading,
    userActivityLoading,
    activityStatsLoading,
    documentsLoading,
}) => {
    return (
        <>
            <AddStaffDrawer
                visible={editOpen}
                editingStaff={editOpen ? editingStaffForDrawer : null}
                onClose={() => {
                    setEditOpen(false);
                    refetchProfile();
                }}
            />
            <UserProfilePicChangeModal
                showModal={profilePicModalOpen}
                setProfilePicModal={setProfilePicModalOpen}
                setShowConfirmModal={handleRemovePhotoConfirm}
                setFlag={() => { }}
                handleOk={handleProfilePicModalOk}
                src={existingPhotoSrc || ""}
                ref={inputProfilePicRef}
                setfileInputValue={storeImageFile}
                handleCancel={handleProfilePicCancel || (() => setProfilePicModalOpen(false))}
                onOk={(callback, buttonCallback) => handleConfirmPhotoChoice(callback, buttonCallback)}
                setImgUrl={setImgUrl}
                imgUrl={imgUrl}
                imageFile={imageFile}
                setImageFile={setImageFile}
            />
            <AddDocumentModal
                visible={!!documentModal}
                mode={documentModal?.mode || 'add'}
                onClose={() => setDocumentModal(null)}
                onUpload={(file, callback) => handleReplaceDocument(documentModal?.docId, file, callback)}
                onFilesSelected={handleUploadDocuments}
            />
            <EnrollCourseModal
                visible={enrollCourseModalOpen}
                onClose={() => setEnrollCourseModalOpen(false)}
                onEnroll={handleEnrollCourse}
                userId={userId}
                enrolledCourses={enrolledCourses}
            />
            <AddBatchDrawer
                visible={!!addBatchDrawerData}
                courseName={addBatchDrawerData?.courseName}
                courseId={addBatchDrawerData?.courseId}
                courseType={addBatchDrawerData?.courseType}
                onClose={() => setAddBatchDrawerData(null)}
            />
            <SavingModal
                visible={!!unassignCourseModal}
                title="Confirm"
                message={`Once you confirm, the user will be unassigned from ${unassignCourseModal?.title ? `"${unassignCourseModal.title}"` : 'this course'}.`}
                confirmText="YES, UNASSIGN"
                cancelText="CANCEL"
                swapButtons={true}
                confirmButtonStyle={{ border: '1.5px solid #FF414D', background: '#FFFFFF', color: '#FF414D' }}
                cancelButtonStyle={{ background: '#594099', color: '#FFFFFF', border: 'none' }}
                loading={unassigningCourse}
                loadingText="UNASSIGNING..."
                onCancel={() => !unassigningCourse && setUnassignCourseModal(null)}
                onConfirm={handleConfirmUnassignCourse}
            />
            <ChangeBatchModal
                visible={!!changeBatchModalData}
                onClose={() => setChangeBatchModalData(null)}
                onAssign={handleChangeStudentBatch}
                title={changeBatchModalData?.modalTitle || "Change batch"}
                courseName={changeBatchModalData?.courseName}
                courseId={changeBatchModalData?.courseId}
                currentStandardId={changeBatchModalData?.currentStandardId}
                excludeStandardIds={changeBatchModalData?.excludeStandardIds}
            />
            <SavingModal
                visible={!!unassignBatchModal}
                title="Confirm"
                message={`Once you confirm, the user will be unassigned from ${unassignBatchModal?.batch?.name ? `"${unassignBatchModal.batch.name}"` : 'this batch'}.`}
                confirmText="YES, UNASSIGN"
                cancelText="CANCEL"
                swapButtons={true}
                confirmButtonStyle={{ border: '1.5px solid #FF414D', background: '#FFFFFF', color: '#FF414D' }}
                cancelButtonStyle={{ background: '#594099', color: '#FFFFFF', border: 'none' }}
                loading={unassigningBatch}
                loadingText="UNASSIGNING..."
                onCancel={() => !unassigningBatch && setUnassignBatchModal(null)}
                onConfirm={handleConfirmUnassignBatch}
            />
            <SavingModal
                visible={!!cancelRequestModal}
                title="Cancel Request"
                message={`Are you sure you want to cancel the request for ${cancelRequestModal?.name || "this installment"}?`}
                confirmText={cancelingRequest ? "CANCELING..." : "YES, CANCEL"}
                cancelText="CANCEL"
                swapButtons={true}
                confirmButtonStyle={{ border: '1.5px solid #FF414D', background: '#FFFFFF', color: '#FF414D' }}
                cancelButtonStyle={{ background: '#594099', color: '#FFFFFF', border: 'none' }}
                onCancel={() => !cancelingRequest && setCancelRequestModal(null)}
                onConfirm={handleConfirmCancelRequest}
            />
            <UserActionConfirmModal
                open={!!confirmAction}
                onCancel={closeConfirmModal}
                onConfirm={handleConfirmAction}
                action={confirmAction || 'suspend'}
                loading={confirmLoading}
                isBulk={false}
            />
            <PageDataLoader visible={tabLoader || pageLoader || enrolledCoursesLoading || studentFeeLoading || userActivityLoading || activityStatsLoading || documentsLoading} />
        </>
    );
};

export default ProfileModals;
